// extracted by mini-css-extract-plugin
module.exports = {"content":"Fitting_content__2OoKN","submitBtn":"Fitting_submitBtn__3jiGO"};